var CommunityHour = function (src) {
    var self = this;
    src = src || {};

    self.NPHoursId = src.NPHoursId || 0;
    self.ProjectId = src.ProjectId || 0;
    self.ProjectDescription = src.ProjectDescription || '';
    self.StudentId = src.StudentId || 0;
    self.CalendarYear = src.CalendarYear || 0;
    self.FirstName = src.FirstName || '';
    self.MiddleInitial = src.MiddleInitial || '';
    self.LastName = src.LastName || '';
    self.IsPLC = src.IsPLC || false;
    self.DispatchDate = src.DispatchDate || '';
    self.ReturnedDate = src.ReturnedDate || '';
    self.EstimatedHours = src.EstimatedHours || 0;
    self.ForestName = src.ForestName || '',
        self.Hours = src.Hours || 0;
    self.Active = src.Active || 1;
    self.Deleted = src.Deleted || 0;
    self.Creator = src.Creator || '';
    self.LastModifiedBy = src.LastModifiedBy || '';
    self.CreatedDate = src.CreatedDate || new Date();
    self.CreatedDateString = src.CreatedDateString || '';
    self.CreatedBy = src.CreatedBy || '';
    self.LastUpdated = src.LastUpdated || new Date();
    self.LastUpdatedString = src.LastUpdatedString || '';
    self.LastUpdatedBy = src.LastUpdatedBy || '';
    self.UpdatingApp = src.UpdatingApp || '';
    return self;
};

CommunityHour.prototype.fullName = function () {
    return (this.LastName || '') + ', ' + (this.FirtName || '') + this.MiddleInitial + ' ';
};
CommunityHour.prototype.dispatchDateISO = function () {
    if (this.DispatchDate == '')
        return '';
    else
        return new Date(this.DispatchDate);
};
CommunityHour.prototype.returnedDateISO = function () {
    if (this.ReturnedDate == '')
        return '';
    else
        return new Date(this.ReturnedDate);
};
angular.module('jcsfApp').value('CommunityHour', CommunityHour);